import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useLeague } from '../contexts/LeagueContext'
import {
  sectionEnabled,
  addonEntitled,
  type SiteSectionKey,
  type AddonKey,
} from '../contexts/tenantAccess'

// Public route guards (switch model).
//
// A tenant-admin "site section" switched off hides the nav link AND the page:
// a direct URL redirects to the homepage. Add-on pages (live events, tickets)
// redirect when the league isn't entitled. The backend is the real gate
// for add-on data (it answers 403/404); these guards just keep fans from
// landing on an empty shell.
//
// Both fail OPEN while the tenant payload is unknown (null league, or an older
// payload without site_sections / addons), so first paint never bounces a fan
// off a page the league actually has. The account-status gate (suspended /
// paused) is publicGateFor() in contexts/tenantAccess.ts.

export function SectionRoute({ section, children }: { section: SiteSectionKey; children: ReactNode }) {
  const { league } = useLeague()
  if (league && !sectionEnabled(league, section)) return <Navigate to="/" replace />
  return <>{children}</>
}

export function AddonRoute({ addon, children }: { addon: AddonKey; children: ReactNode }) {
  const { league } = useLeague()
  if (league && !addonEntitled(league, addon)) return <Navigate to="/" replace />
  return <>{children}</>
}
